import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function Portal({ children, rootId = 'portal' }) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    let root = document.getElementById(rootId);

    // Create root if it doesn't exist
    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      document.body.appendChild(root);
    }

    // Create element for this portal instance
    const el = document.createElement('div');
    root.appendChild(el);
    setContainer(el);

    return () => {
      root.removeChild(el);
      if (root.childNodes.length === 0) {
        root.remove();
      }
    };
  }, [rootId]);

  if (!container) return null;

  return createPortal(children, container);
}
